<script setup lang="ts">
  import { IconEPC } from '@ui-kit';
  import { ScanModal } from '../ScanModal';

  const emit = defineEmits<{
    'click:back': [value: void];
    'click:btn': [value: void];
  }>();
</script>

<template>
  <ScanModal
    :title="$t('EPC метка от другого товара')"
    :subtitle="$t('Вы уверены, что отсканировали EPC метку с первоначальной этикетки?')"
    :btnTitle="$t('Да, эта метка от моего товара')"
    @click:back="emit('click:back')"
    @click:btn="emit('click:btn')"
    data-testid="incorrect-epc"
  >
    <template #icon>
      <IconEPC />
    </template>
    <slot />
  </ScanModal>
</template>